import { SubjectRole } from "../generated/graphql"
import { RolesUiDisplayObj } from "../util/subjectRole"

class Policy_OrganizationMembership {
    private constructor() {
        return
    }

    /**
     * Check if the role can update the activate/deactivate status of a subject
     * Only available to PPO Admin
     * @param role
     * @returns boolean
     */
    static canUpdateSubjectActivationStatus(role: SubjectRole) {
        return [SubjectRole.PpoAdmin].includes(role)
    }

    /**
     * Check if the role can only fetch active users
     * Org Admin or Org Member can only fetch active users
     * PPO Admin can fetch all users
     * @param role
     * @returns boolean
     */
    static canOnlyFetchActiveUsers(role: SubjectRole) {
        return [SubjectRole.OrgAdmin, SubjectRole.OrgMember].includes(role)
    }

    /**
     * Check if the role can have managed access
     * Only Org Member can have managed access
     * Org Admin and PPO Admin can not be set to have managed access
     * @param role
     * @returns boolean
     */
    static canHaveManagedAccessOrganizationMembership(role: SubjectRole) {
        return [SubjectRole.OrgMember].includes(role)
    }

    /**
     * getPermittedInviteRoles
     * gets role invitation options for a provided role
     * PPO Admin can invite any role
     * Org Admin can invite Org Admin and Org Member
     * Org Member can not invite any roles
     * @role - the role to get the invitation options for
     * @returns LabelValueOptionType[]
     */
    static getPermittedInviteRoles(inviterRole: SubjectRole) {
        switch (inviterRole) {
            case SubjectRole.PpoAdmin:
                return [
                    {
                        label: RolesUiDisplayObj[SubjectRole.PpoAdmin],
                        value: SubjectRole.PpoAdmin,
                    },
                    {
                        label: RolesUiDisplayObj[SubjectRole.OrgAdmin],
                        value: SubjectRole.OrgAdmin,
                    },
                    {
                        label: RolesUiDisplayObj[SubjectRole.OrgMember],
                        value: SubjectRole.OrgMember,
                    },
                ]
            case SubjectRole.OrgAdmin:
                return [
                    {
                        label: RolesUiDisplayObj[SubjectRole.OrgAdmin],
                        value: SubjectRole.OrgAdmin,
                    },
                    {
                        label: RolesUiDisplayObj[SubjectRole.OrgMember],
                        value: SubjectRole.OrgMember,
                    },
                ]
            case SubjectRole.OrgMember:
            case SubjectRole.System:
            case SubjectRole.Unknown:
                throw new Error(
                    "getRoleInvitationOptions - Unknown, System && OrgMember roles should not have access to invite user modal"
                )
        }
    }

    /**
     * Check if the role can invite a user
     * PPO Admin and Org Admin can invite a user
     * Org Member can not invite a user
     * @param role
     * @returns boolean
     */
    static canInviteUser(role: SubjectRole) {
        return [SubjectRole.PpoAdmin, SubjectRole.OrgAdmin].includes(role)
    }
}

export default Policy_OrganizationMembership
